/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import MiniLogo from '../app/MiniLogo.react';
import {ChannelGrantedOnMount, testChannelAuth} from './ChannelGranted.react';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';

const messages = defineMessages({
    title: {id: 'channelGranted.title', 'defaultMessage': 'Application access granted'}
});

class ChannelGrantedInPanel extends React.Component {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired,
    };

    typeName = 'channels';

    static contextTypes = {
        router: PropTypes.object,
    };

    constructor() {
        super();
    }

    componentDidMount() {
		ChannelGrantedOnMount(this.props.relay).then((response) => {
            let channel = response.grantAccess.channel;
            if (response.grantAccess.redirectUrl) {
                window.location = response.grantAccess.redirectUrl;
                return;
            }

            return testChannelAuth(channel, this.props.relay).then(() => {
                response.eventName = 'dativery-grand-access-saved';
                return response;
            });
		}, (transaction) => {
			let error;

			if (transaction && transaction.getError && typeof transaction.getError === 'function') {
				error = transaction.getError();
			}
			else if (transaction) {
				error = transaction;
				error.message = error.message || "Mutation failed.";
			}
			else {
				error = new Error('Mutation failed.');
			}

			error.eventName = 'dativery-grand-access-error';
			return error;
		}).then((res) => {
			// window.opener.postMessage(res, '*');
			window.opener.focus();
			window.close();
		}).catch((e) => {
			throw new Error(e);
		});
    }

    render() {
        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)}>
                <center>
					<LoadingLine />
                    <MiniLogo color width="150px"/>
                    <p><strong><FormattedMessage defaultMessage="Saving…" id="channelGranted.saving" /></strong></p>
                </center>
            </AppPanel>
        );
    }
}


export default Relay.createContainer(injectIntl(ChannelGrantedInPanel), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id
            }
        `,
    },
});
